<script>
import bgc1 from "@/assets/recruit/bgc1.jpg";
import bgc2 from "@/assets/recruit/bgc2.jpg";
import bgc3 from "@/assets/recruit/bgc3.jpg";
import bgc4 from "@/assets/recruit/bgc4.jpg";
import btn from "@/assets/recruit/btn.png";
import { saveRecruitForm, sendMessege, verifySnsCode } from "@/api/common";
import { vaildPhone } from "@/hooks/useFormValidator";
import { areaList } from "@vant/area-data";
import dayjs from "dayjs";

export default {
  name: "",
  data: () => {
    return {
      bgc1,
      bgc2,
      bgc3,
      bgc4,
      btn,
      form: {},
      showAreaPicker: false,
      showPlatformPicker: false,
      showDatePicker: false,
      showPositionPicker: { positionA: false, positionB: false },
      areaList,
      address: "",
      rules: [{ required: true, message: "必填" }],
      currentDate: new Date(),
      minDate: new Date(1979, 0, 1),
      maxDate: new Date(),
      verifyCode: "",
      title: "新星慕粉队招募令",
      loading: false,
      smsStatus: 0, // 发送验证码状态0，未发送 1 已发送
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const { phone, real_name, user_id, member_id } = this.$route.query;
      this.form = {
        phone,
        realName: real_name,
        userId: user_id,
        memberId: member_id,
      };
    },
    vaildPhone,
    async sendSms() {
      try {
        await this.$refs.formRef.validate(["phone"]);
        this.loading = true;
        const params = {
          project: this.title, // 调用项目：CRM
          phone: this.form.phone, // 调用电话：多个时用分号隔开，上限500个
          sender: 8822072204468,
          signName: "慕思", // 签名：慕思
          tempCode: "010bffe48c3d46d7bf837fa3eb084134", // 模板code: SMS_182541596
          operType: "CAPTCHA", // 操作类型：CAPTCHA 验证码类短信、NOTE 通知类短信
          tempParam: "{}", // 模板中的变量，json字符串，验证码code非空时，直接进行验证码处理，验证码code为空时，由接口自动生成
          mhzTime: 1, // 验证码发送频率时长，范围：1分钟~2分钟，默认：1分钟
          validTime: 10, // 验证码有效时间，范围：5分钟~30分钟，默认：5分钟
        };
        sendMessege(params).then((res) => {
          const message = res.code != 0 ? res.msg : "发送成功";
          this.smsStatus = res.code == 0 ? 1 : 0;
          this.$toast(message);
        });
      } finally {
        this.loading = false;
      }
    },
    onFailed({ errors = [] }) {
      if (errors[0]?.name) this.$refs.formRef.scrollToField(errors[0]?.name);
    },
    async onSubmit() {
      try {
        this.loading = true;
        const { code, msg } = await verifySnsCode({
          phone: this.form.phone,
          verifyCode: this.verifyCode,
        });

        if (code != 0) {
          this.$toast(msg);
          return;
        }
        const res = await saveRecruitForm(this.form);
        if (res.code != 0) {
          this.$toast(res.msg || "报名失败");
          return;
        }
        this.init();
        this.$toast("报名成功");
      } finally {
        this.loading = false;
      }
    },
    onAreaConfirm(value) {
      const [province, city] = value.map((item) => item.name);
      this.form = { ...this.form, province, city };
      this.showAreaPicker = false;
      this.address = [province, city].join(" ");
    },
    onPlatformConfirm(value) {
      this.form = { ...this.form, platformType: value };
      this.showPlatformPicker = false;
    },
    onBirthdayConfirm(value) {
      this.form = { ...this.form, birthday: dayjs(value).format("YYYY-MM-DD") };
      this.showDatePicker = false;
    },
    onPositionConfirm(value, key) {
      this.form = { ...this.form, [key]: value };
      this.showPositionPicker[key] = false;
    },
  },
};
</script>

<template>
  <div class="view">
    <van-image class="bgc" fit="contain" width="100%" :src="bgc1" />
    <van-image class="bgc" fit="contain" width="100%" :src="bgc2" />
    <div class="form-wrapper">
      <div class="form-main" :style="{ backgroundImage: 'url(' + bgc3 + ')' }">
        <van-form
          ref="formRef"
          class="form-content"
          @submit="onSubmit"
          @failed="onFailed"
        >
          <van-field
            v-model="form.realName"
            name="realName"
            label="姓名"
            placeholder="请输入姓名"
            :rules="rules"
            :maxlength="20"
          />
          <van-field
            readonly
            clickable
            name="birthday"
            v-model="form.birthday"
            label="出生年月"
            placeholder="点击选择年月日"
            :rules="rules"
            @click="showDatePicker = true"
          />
          <van-popup v-model="showDatePicker" position="bottom">
            <van-datetime-picker
              v-model="currentDate"
              type="date"
              title="选择年月日"
              :min-date="minDate"
              :max-date="maxDate"
              @confirm="onBirthdayConfirm"
            />
          </van-popup>

          <van-field
            v-for="(formItem, formKey) in {
              height: '身高(cm)',
              weight: '体重(kg)',
            }"
            :key="formKey"
            v-model="form[formKey]"
            :name="formKey"
            :label="formItem"
            :maxlength="5"
            type="digit"
            :rules="rules"
            :placeholder="`请输入${formItem}`"
          />

          <div class="form-item">
            <van-field
              class="form-item__title"
              v-model="form.phone"
              name="phone"
              label="联系电话"
              :maxlength="11"
              type="tel"
              :rules="[
                ...rules,
                { validator: vaildPhone, message: '手机号码格式有误' },
              ]"
              placeholder="请输入手机号码"
            />

            <van-field
              v-model="verifyCode"
              name="verifyCode"
              center
              clearable
              placeholder="请输入短信验证码"
              :rules="rules"
            >
              <template #button>
                <van-button
                  size="small"
                  type="primary"
                  native-type="button"
                  :disabled="smsStatus == 1"
                  @click="sendSms"
                >
                  <van-count-down
                    v-if="smsStatus == 1"
                    class=""
                    ref="countdownRef"
                    :time="1000 * 60"
                    format="ss"
                    @finish="smsStatus = 0"
                  />
                  <label v-else>发送验证码</label>
                </van-button>
              </template>
            </van-field>
          </div>

          <div class="form-item">
            <van-cell class="form-item__title" title="球场位置" />
            <div
              v-for="(formItem, formKey) in {
                positionA: '主打',
                positionB: '备选',
              }"
              :key="formKey"
            >
              <van-field
                readonly
                clickable
                :name="formKey"
                v-model="form[formKey]"
                :label="formItem"
                :placeholder="`点击选择${formItem}`"
                :rules="rules"
                @click="() => (showPositionPicker[formKey] = true)"
              />
              <van-popup
                v-model="showPositionPicker[formKey]"
                position="bottom"
                get-container="body"
              >
                <van-picker
                  show-toolbar
                  :columns="[
                    '控球后卫',
                    '得分后卫',
                    '小前锋',
                    '大前锋',
                    '中锋',
                  ]"
                  @confirm="(value) => onPositionConfirm(value, formKey)"
                  @cancel="() => (showPositionPicker[formKey] = true)"
                />
              </van-popup>
            </div>
          </div>

          <van-field
            readonly
            clickable
            name="address"
            v-model="address"
            label="现居住地"
            placeholder="点击选择省市区"
            @click="showAreaPicker = true"
          />
          <van-popup
            v-model="showAreaPicker"
            position="bottom"
            get-container="body"
          >
            <van-area
              :area-list="areaList"
              :columns-num="2"
              @confirm="onAreaConfirm"
              @cancel="showAreaPicker = false"
            />
          </van-popup>

          <van-field
            v-for="(formItem, formKey) in {
              shopName: '消费门店',
              orderNumber: '消费订单号',
            }"
            :key="formKey"
            v-model="form[formKey]"
            :name="formKey"
            :label="formItem"
            :rules="rules"
            :placeholder="`请输入${formItem}`"
            :maxlength="100"
          />

          <div class="form-item">
            <van-cell
              class="form-item__title"
              title="篮球比赛/协会/俱乐部等篮球经历"
              label="（曾获篮球赛事奖项等可重点填写）"
            />
            <van-field
              v-model="form.remark"
              rows="2"
              autosize
              name="remark"
              type="textarea"
              maxlength="250"
              placeholder="请输入经历"
              show-word-limit
              :rules="rules"
            />
          </div>

          <div class="form-item">
            <van-cell
              class="form-item__title"
              title="篮球展示视频发布社媒平台"
            />
            <van-field
              readonly
              clickable
              name="platformType"
              v-model="form.platformType"
              placeholder="点击选择平台"
              :rules="rules"
              @click="showPlatformPicker = true"
            />
            <van-popup
              v-model="showPlatformPicker"
              position="bottom"
              get-container="body"
            >
              <van-picker
                show-toolbar
                :columns="['抖音', '小红书', '微博']"
                @confirm="onPlatformConfirm"
                @cancel="showPlatformPicker = false"
              />
            </van-popup>

            <van-field
              v-for="(formItem, formKey) in {
                platformNumber: '账号ID',
                platformUrl: '视频链接',
              }"
              :key="formKey"
              v-model="form[formKey]"
              :name="formKey"
              :label="formItem"
              :rules="rules"
              :maxlength="300"
              :placeholder="`请输入${formItem}`"
            />
          </div>

          <div class="tips">
            *请录制1段个人打篮球的展示视频，发布自媒体平台，带话题#国际篮球全明星慕思嘉年华@慕思官方账号
            （微博@慕思寝具、抖音@慕思DeRUCCI、小红书@慕思寝具）
          </div>

          <div class="form-footer">
            <van-button
              class="form-submit__btn"
              round
              block
              type="info"
              :loading="loading"
              native-type="submit"
            >
              提交
            </van-button>
            <van-image class="bgc" fit="contain" width="100%" :src="btn" />
          </div>
        </van-form>
      </div>
    </div>
    <van-image class="bgc" fit="contain" width="100%" :src="bgc4" />
  </div>
</template>

<style lang="scss" scoped>
.view {
  background-color: #050514;
}
.bgc {
  vertical-align: middle;
}

.form-wrapper {
  margin-top: -2px;
}
.form-main {
  padding-top: 10px;
  min-height: 400px;
  background-repeat: no-repeat;
  background-size: 100vw 100%;
  background-position: center;
  .form-content {
    padding: 0 40px;
    &::v-deep .van-cell {
      border-radius: 6px;
      margin-bottom: 10px;
      overflow: hidden;
    }
  }
  .form-item {
    background-color: #fff;
    border-radius: 6px;
    .form-item__title {
      margin-bottom: 0;
    }
  }
}
.form-footer {
  margin: 16px;
  margin-bottom: 0;
  padding-bottom: 20px;
  position: relative;
  .form-submit__btn {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    z-index: 1;
    height: 72px;
    opacity: 0;
  }
}
.tips {
  font-size: 10px;
  color: #fff;
}
::v-deep .van-count-down {
  color: #fff;
}
</style>
